import constants from '@/const/'

const actions = {
	switchYMIntegrationType: function ({ state, commit, getters, rootState }, input) {
		return new Promise((resolve, reject) => {
			rootState.request({
				type: constants.METHODS.PUT,
				apiName: 'seowork',
				query: {
					yla_id: input
				},
				url: '/metrica/client/integration/switch',
				auth: true
			}).then(() => {
				resolve(true)
			}, () => {
				// eslint-disable-next-line prefer-promise-reject-errors
				reject('Не удалось обновить тип интеграции Яндекс Метрики')
			})
		})
	}
}

export default actions
